import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface IProps {
  disabled?: boolean;
  left?: boolean;
  onClick: () => void;
}

export const NavigationButton = observer((props: IProps): ReactElement => {
  const { onClick, disabled, left } = props;
  return (
    <div className='date-navigation-button'>
      <Button
        disabled={disabled}
        onClick={onClick}
      >
        <FontAwesomeIcon icon={left ? faAngleLeft : faAngleRight} />
      </Button>
    </div>
  );
});
